import request from '@/utils/request'
//账号登录
export function accountLogin(data) {
    return request({
        url: `/Account/AccountLogin`,
        method: 'post',
        data
    })
}

//手机发送短信
export function sendSMS(data) {
    return request({
        url: `/Account/SendSMS`,
        method: 'post',
        data
    })
}

//手机登录
export function mobileLogin(data) {
    return request({
        url: `/Account/MobileLogin`,
        method: 'post',
        data
    })
}

//手机登录
export function getImUserSig() {
    return request({
        url: `/MemberMsg/GetImUserSig`,
        method: 'post',
    })
}